import { Component, forwardRef, inject, input } from '@angular/core';
import { IconDto } from '@core/services/api-clients';
import { ContextService } from '@core/services/context.service';
import { WidgetDirective } from '@core/widgets/directives/widget.directive';
import { IScriptRunnerService, SCRIPT_RUNNER_SERVICE } from '@core/widgets/models/iscript-runner.service';
import { WidgetType } from '@core/widgets/models/widget-type';
import { Observable } from 'rxjs';
import { IExecutionContext, IExecutionEvent } from 'src/engine-sdk';
import { IconComponent } from '../../../../shared/icon/icon.component';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  providers: [
    {
      provide: WidgetDirective,
      useExisting: forwardRef(() => MenuItemComponent),
    },
  ],
  imports: [IconComponent],
})
export class MenuItemComponent extends WidgetDirective {
  private _contextService = inject(ContextService);

  readonly name = input<string>('');
  readonly label = input<string>('');
  readonly shortLabel = input<string>('');
  readonly icon = input<IconDto>(null);
  readonly isWide = input<boolean>(false);
  readonly isRootLevel = input<boolean>(true);
  readonly isSelected = input<boolean>(false);

  public constructor() {
    const parentWidget = inject(WidgetDirective, { optional: true, skipSelf: true });
    const scriptRunnerService = inject<IScriptRunnerService>(SCRIPT_RUNNER_SERVICE);

    super(parentWidget, scriptRunnerService);
    this._isOnClickEventSupported = true;
  }

  getWidgetType(): WidgetType {
    return WidgetType.MenuItem;
  }

  getExecutionContext(executionEvent: IExecutionEvent): Observable<IExecutionContext> {
    return this._contextService.createMenuItemExecutionContext(this._events$, executionEvent);
  }
}
